import { Page } from "components/page/page.component"
import { View } from "components/view/view.component"
// import { Text } from 'components/text/text.component'
import style from './visitantesRestauranteReport.module.css'
// import { Skeleton } from "components/skeleton"
// import { Table, TableBody, TableCell, TableHead, TableRow } from "components/table/table.component"
import { useState } from "react"
import { getDaysBefore } from "utils/date.util"
import { Button } from "components/button/button.component"
import { Icon } from "components/icon/icon.component"
import { Filters } from "components/filters/filters.component"
import { FilterType } from "model/filter.model"
import { useGetVisitantesRestauranteReportApi } from "api/reports.api"
import { downloadPDFReportFile } from "utils/pdfReportHook.util"
import { downloadExcelReportFile } from "utils/excelReportHook.util"
import { z } from "zod"
import { Alert } from "components/alert/alert.component"
import { createVisitantesRestauranteReportData } from "reports/visitantesRestaurante.data.report"

type VisitantesRestauranteReportPageProps = {
    companyId?: string
}
export function VisitantesRestauranteReportPage({companyId}: VisitantesRestauranteReportPageProps){
    const [filter, setFilter] = useState<FilterType | undefined>()
    const [loading, setLoading] = useState(false)
    const [maxDateIntervalError, setMaxDateIntervalError] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | undefined>()

    const { get } = useGetVisitantesRestauranteReportApi()

    // const reportData = createRoomOccupationReportData( data )

    // const {loading: loadingExcelReport, download: downloadExcelReport} = useExcelReport({data: reportData ,fileName: 'AROTech - Relatorio de ocupação de salas'})
    // const {loading: loadingPDFReport, download: downloadPDFReport} = usePDFReport({ data: reportData, fileName: 'AROTech - Relatorio de ocupação de salas', title: 'Relatorio de ocupação de salas'} )

    function handleOnFilterChange(filter: FilterType){
        setErrorMessage(undefined)
        setFilter(filter)
    }

    function validateResponse(data: any){
        const schema = z.object({
            building: z.string().optional().nullable(),
            area: z.string().optional().nullable(),
            room: z.string(),
            date: z.string().transform((str) => new Date(str)).optional().nullable(),
            value: z.number().optional().nullable()
        })
        const arraySchema = z.array(schema)
        const result = arraySchema.safeParse(data)
        if(result.success) return result.data
        return []
    }

    async function getData(){
        if(!companyId) return
        if(!filter?.startDate) return
        if(!filter?.endDate) return
        if(!filter?.rooms) return
        const _filter = {
            rooms: filter.rooms,
            startDate: filter.startDate,
            endDate: filter.endDate
        }
        return await get(_filter, validateResponse)
    }

    async function downloadExcelReport(){
        setErrorMessage(undefined)
        if(maxDateIntervalError) return
        setLoading(true)
        const now = new Date()
        try {
            const data = await getData()
            if(!data) throw new Error('No data received');
            const reportData = createVisitantesRestauranteReportData(data)
            await downloadExcelReportFile(reportData, 'AROTech - Relatorio de visitantes de restaurantes', 'Relatorio de visitantes de restaurantes')
        } catch (error) {
            console.error(`interval error at ${((new Date()).getTime() - now.getTime()) / 1000} s`);
            console.error('Error downloading Excel report:', error)
            setErrorMessage('Erro ao gerar o relatório. Tente reduzir o intervalo de datas ou o número de restaurantes selecionados.')
        }
        setLoading(false)
    }

    async function downloadPDFReport(){
        setErrorMessage(undefined)
        if(maxDateIntervalError) return
        setLoading(true)
        try {
            const data = await getData()
            if(!data) throw new Error('No data received');
            const reportData = createVisitantesRestauranteReportData(data)
            await downloadPDFReportFile(reportData, 'AROTech - Relatorio de visitantes de restaurantes', 'Relatorio de visitantes de restaurantes')
        } catch (error) {
            console.error('Error downloading PDF report:', error)
            setErrorMessage('Erro ao gerar o relatório. Tente reduzir o intervalo de datas ou o número de restaurantes selecionados.')
        }
        setLoading(false)
    }

    // get max date interval in minutes of rooms
    function getMaxDateIntervalFromNumberOfRooms(roomsCount: number): number {
        const maxRows = 200000
        const maxRowsPerRoom = Math.floor(maxRows / roomsCount)
        // each row represents 15 minutes
        return maxRowsPerRoom * 15
    }
    
    return <Page menu header title="Relatório Número de Visitantes do Restaurante">
        <View className={style.Content}>
            
        <View className={style.ContentHeader}>
            <Filters 
                companyId={companyId} 
                // showBuildings
                // showAreas
                showRooms
                hideBuildingFromRoomsOptions
                hideAreaFromRoomsOptions
                roomsTitle="Restaurantes"
                showStartDate
                initialStartDate={getDaysBefore(new Date(), 1)}
                showEndDate
                initialEndDate={new Date()}
                dateType="datetime" 
                onChange={handleOnFilterChange}
                roomIndicatorIds={['room-visitors-count']}
                selectAllAreasWhenBuildingChanges
                selectAllRoomsWhenAreaChanges
                maxDateInterval={getMaxDateIntervalFromNumberOfRooms(filter?.rooms?.length || 1)}
                onDateIntervalError={setMaxDateIntervalError}
            />
            {/* <Button 
                variant='contained' 
                startIcon={<Icon className={style.Icons}>search</Icon>}
                onClick={getData}
                disabled={!filter || !filter.startDate || !filter.endDate || !filter.rooms || filter.rooms.length <= 0}
                loading={loading}
            >
                Gerar Relatório
            </Button> */}
        </View>
        <View className={style.ExportSection}>
            <View className={style.ExportSectionButtons}>
                <Button variant='contained' startIcon={<Icon className={style.Icons}>picture_as_pdf</Icon>}
                    onClick={downloadPDFReport}
                    // disabled={!data || data.length <= 0}
                    disabled={!filter || !filter.startDate || !filter.endDate || !filter.rooms || filter.rooms.length <= 0 || maxDateIntervalError}
                    loading={loading}
                >
                    Exportar para PDF
                </Button>
                <Button 
                    variant='contained' 
                    startIcon={<Icon className={style.Icons}>border_all</Icon>}
                    loading={loading}
                    onClick={downloadExcelReport}
                    // disabled={!data || data.length <= 0}
                    disabled={!filter || !filter.startDate || !filter.endDate || !filter.rooms || filter.rooms.length <= 0 || maxDateIntervalError}
                >
                    Exportar para Excel
                </Button>
            </View>
            {errorMessage && <Alert severity="error" onClose={() => {setErrorMessage(undefined) }} style={{marginTop: '50px'}}>
                {errorMessage}
            </Alert>}
        </View>
    {/* {loading
    ? <Skeleton className={style.TableContainer} />
    :<View className={style.TableContainer}>
        <View className={style.TableContent}>
                <Table >
                    <TableHead>
                        <TableRow>
                            {reportData.titles.map(_ => <TableCell><Text type='h4'>{_}</Text></TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                        (!data || data?.length <= 0) &&(!filter?.rooms || filter?.rooms.length <= 0)
                        ?<TableRow className={style.Content}>
                            <TableCell colSpan={7}>
                                <Text type='sm'>Selecione uma sala</Text>
                            </TableCell>
                        </TableRow>
                        : (!data || data?.length <= 0)
                        ? <TableRow className={style.Content}>
                            <TableCell colSpan={7}>
                                <Text type='sm'>Nenhum Lançamento encontrado</Text>
                            </TableCell>
                        </TableRow>
                        : reportData.rows.map((row, index) => <TableRow key={index}>
                            {row.map(_ => <TableCell><Text type='sm'>{ _ }</Text></TableCell>)}
                        </TableRow>)
                        }
                    </TableBody>
                </Table>
        </View>
    </View>
    } */}
    </View>
    </Page>
}